import { useEffect, useState } from "react";

const KEY = "observer.theme";
const EVT = "observer-theme";

export const getTheme = () => localStorage.getItem(KEY) || "dark";

export function applyTheme(t) {
  document.documentElement.dataset.theme = t;
  document.documentElement.classList.toggle("dark", t === "dark");
}

export function setTheme(t) {
  localStorage.setItem(KEY, t);
  applyTheme(t);
  window.dispatchEvent(new CustomEvent(EVT, { detail: t }));
}

export function useTheme() {
  const [theme, set] = useState(getTheme);
  useEffect(() => {
    const on = (e) => set(e.detail);
    window.addEventListener(EVT, on);
    return () => window.removeEventListener(EVT, on);
  }, []);
  return [theme, () => setTheme(theme === "dark" ? "light" : "dark")];
}

applyTheme(getTheme());
